<div class="products">
  <div class="products-container">
    <h3 class="products-container__title">{{productsContent.title}}</h3>
    <div class="products-container__items">
      @for (product of productsContent.productTiles; track product) {
        <div class="products-container__items-card">
          <img class="products-container__items-card--logo" [src]="blobURL + product.logo">
          <h4 class="products-container__items-card--name">{{product.name}}</h4>
          <p class="products-container__items-card--description">{{product.description}}</p>
          <div class="products-container__items-card--navigation">
            @for (link of product.navigation; track link) {
              <div class="products-container__items-card--navigation-item">
                @if (checkToDisplayLink(product)) {
                  <a class="products-container__items-card--navigation-item--link"
                    (click)="navigateTo(link)">
                    {{link.text}}
                  </a>
                }
                @if (checkToDisplayLink(product)) {
                  <img class="products-container__items-card--navigation-item--img" [src]="blobURL + link.logo">
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
